<template>
  <a-tooltip
    placement="topLeft"
    arrow-point-at-center
    :get-popup-container="getPopupContainer"
    :overlayStyle="{'max-width': '400px'}"
  >
    <template v-if="isTruncated" slot="title">
      {{ info }}
    </template>
    <p ref="info" class="info-text">{{ info }}</p>
  </a-tooltip>
</template>

<script>
export default {
  props: {
    info: {
      type: String,
      default: '-',
      required: true,
    },
  },
  data: () => ({
    isTruncated: false,
    observer: null,
  }),
  watch: {
    info() {
      this.$nextTick(() => {
        this.checkTruncation()
      })
    },
  },
  methods: {
    getPopupContainer() {
      return document.body
    },
    checkTruncation() {
      const el = this.$refs.info
      if (!el) {
        return
      }

      this.isTruncated = el.scrollWidth > el.clientWidth
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.checkTruncation()
    })

    if (window.ResizeObserver) {
      this.observer = new ResizeObserver(() => {
        this.checkTruncation()
      })
      const el = this.$refs.info
      if (el) {
        this.observer.observe(el)
        if (el.parentElement) this.observer.observe(el.parentElement)
      }
    } else {
      this._onResize = () => this.checkTruncation()
      window.addEventListener('resize', this._onResize)
    }
  },
}
</script>

<style lang="scss">
.info-text {
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
